import { types, actions } from './requests'
export const GETMATERIAL_TYPES = {
    ...types('GETMATERIAL'),
}
export const GETMATERIAL_ACTIONS = {
    ...actions('GETMATERIAL'),
}